import test3 from "../../../../../assets/test1 (1).png"
import test2 from "../../../../../assets/test1 (2).png"
import test1 from "../../../../../assets/test1 (3).png"




export const pricingData = [
    {
        product: "https://cdn.blackincae.com/product-images/LungRenewLabel60ML.png",
        title: '1 Bottle',
        subtitle: '30 Day Supply',
        pricePerBottle: 69,
        url: "",
        leastpopular: true,
        popular: false,
        discount: 'You Save $128',
        gurantee: '180-day money-back guarantee',
        originalPrice: "197",
        discountedPrice: "69",
        bestValue: false,

    },
    {
        product: "https://cdn.blackincae.com/product-images/LR_Bottle_Bottle_6_V2_60ML.png",
        title: '6 Bottles',
        subtitle: '180 Day Supply',
        pricePerBottle: 49,
        url: "",
        leastpopular: false,
        popular: true,
        discount:' YOU SAVE $888',
        gurantee: '180-day money-back guarantee',
        bonuses:' 2 Bonuses worth $249',
        originalPrice: "1,182 ",
        discountedPrice: "294",
        bestValue: true,

    }, {
        product: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
        title: '3 Bottles',
        subtitle: '90 Day Supply',
        pricePerBottle: 59,
        url: "",
        leastpopular: false,
        popular: false,
        discount: '  YOU SAVE $414',
        gurantee: '180-day money-back guarantee',
        freeshipping:'Free Shipping',
        originalPrice: "591 ",
        discountedPrice: "177",
        bestValue: false,

    },
]



export const images = [
    { id: "bottom-testi1", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-04.png", alt: "testi-3b-min jpg" },
    { id: "bottom-testi2", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-01.png", alt: "testi-7-min jpg" },
    { id: "bottom-testi3", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-03.png", alt: "testi-2-min (1) jpg" },
    { id: "bottom-testi4", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-02.png", alt: "testi-6-min jpg" },
];


export const testimonials = [
    {
      id: 1,
      img:test1, // Path to Tom's image
      text: "I’ve tried countless sinus sprays and treatments, but nothing works like SinoClear. It provides fast and lasting relief without the harsh side effects of other products. I can finally breathe without feeling stuffed up all day. Highly recommend for anyone with sinus issues!",
      name: "Tom L.",
    },
    {
      id: 2,
      img: test2, // Path to Sarah's image
      text: "I’ve struggled with sinus pressure for years, especially during allergy season. After trying SinoClear, I felt an instant difference. It quickly cleared up my congestion and allowed me to breathe freely again. It's now my go-to solution for sinus discomfort!",
      name: "Sarah J.",
    },
    {
      id: 3,
      img: test3, // Path to Mark's image
      text: "I love that SinoClear is made with natural ingredients. It’s so much safer and more effective than other over-the-counter sinus products I’ve tried. I can feel the difference in just a few minutes, and it keeps my sinuses clear for hours. It’s a must-have in my medicine cabinet!",
      name: "Mark D.",
    },
  ];

 export const stores = [
    {
        name: 'Walgreens',
        logo: 'https://sinoclear.net/pm/images/X-Walgreens_2020_primary_logo.svg'
    },
    {
        name: 'Walmart',
        logo: 'https://sinoclear.net/pm/images/X-Walmart_logo.svg'
    },
    {
        name: 'GNC',
        logo: 'https://sinoclear.net/pm/images/x-gnc-live-well-2.svg'
    },
    {
        name: 'CVS',
        logo: 'https://sinoclear.net/pm/images/X-CVS_Pharmacy_Alt_Logo.svg'
    }
];


  export const studies = [
    { id: '01', url: 'https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette' },
    { id: '02', url: 'https://www.ncbi.nlm.nih.gov/pubmed/9932596' },
    { id: '03', url: 'https://www.ncbi.nlm.nih.gov/pubmed/25339490' },
    { id: '04', url: 'https://ijmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/' },
    { id: '05', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27117852' },
    { id: '06', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title' },
    { id: '07', url: 'https://www.sciencedirect.com/science/article/pii/S1756464614002400' },
    { id: '08', url: 'https://pubmed.ncbi.nlm.nih.gov/28198157/' },
    { id: '09', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27207147' },
    { id: '10', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/' },
    { id: '11', url: 'https://pubmed.ncbi.nlm.nih.gov/12452574/' },
    { id: '12', url: 'https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953' },
    { id: '13', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/' },
    { id: '14', url: 'https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/' },
    { id: '15', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/' },
    { id: '16', url: 'https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients' },
    { id: '17', url: 'https://pubmed.ncbi.nlm.nih.gov/22129334/' },
    { id: '18', url: 'https://www.ncbi.nlm.nih.gov/pubmed/18356331' },
    { id: '19', url: 'https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen' },
    { id: '20', url: 'https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),not%20as%20substitute%20for%20conventional%20chemotherapy' }
];